// @flow

export const styles = {
  container: {
    width: '100%',
    minHeight: 680,
    display: 'flex',
    background: 'black',
    color: 'white',
    'animation-duration': '.7s',
    'transition-timing-function': 'ease-in',
    'animation-fill-mode': 'both',
    'animation-name': 'scaleRight',
    'transform-origin': '0% 50%'
  },
  textContent: {
    padding: '60px 5px 76px 5px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    '& > div': {
      'animation-duration': '0.4s',
      'transition-timing-function': 'ease-in',
      'animation-fill-mode': 'both',
      'animation-name': 'fadeInRight',
      '&:nth-child(2)': {
        'animation-delay': '.7s'
      },
      '&:nth-child(3)': {
        'animation-delay': '.9s'
      }
    }
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    padding: '20px 0 30px 0',
    fontSize: 12,
    lineHeight: '15px',
    color: 'white',
    textDecoration: 'none',
    'animation-duration': '0.4s',
    'animation-delay': '0.5s',
    'transition-timing-function': 'ease-in',
    'animation-fill-mode': 'both',
    'animation-name': 'fadeInRight',
    '& > i': {
      margin: '2px 6px 0 0',
      fontSize: 18,
      transition: 'margin .2s ease-in-out'
    },
    '&:hover': {
      '& > i': {
        marginRight: 12
      }
    }
  },
  clientName: {
    marginBottom: 0,
    fontSize: 16,
    fontFamily: 'TTNorms-Bold'
  },
  title: {
    marginTop: 13,
    marginBottom: 30,
    fontSize: 40,
    lineHeight: '48px',
    fontFamily: 'TTNorms-Bold'
  },
  description: {
    fontSize: 14,
    textAlign: 'justify',
    lineHeight: '24px'
  },
  highlightSection: {
    display: 'flex'
  },
  highlight: {
    maxWidth: 190,
    flex: 1,
    marginRight: 40,
    borderTop: '1px solid rgba(255,255,255,.5)',
    '& > h3': {
      fontFamily: 'TTNorms-Bold',
      fontSize: 14,
      marginBottom: 8,
      marginTop: 12
    },
    '& > p': {
      fontSize: 12,
      lineHeight: '16px',
      marginBottom: 0
    }
  },
  sideImage: {
    position: 'absolute',
    left: '57.8%',
    flexBasis: '42.2%',
    maxWidth: '42.2%',
    height: 680,
    overflow: 'hidden',
    '& > img': {
      width: 673,
      maxWidth: 'unset',
      marginTop: 75,
      marginLeft: 33,
      'animation-duration': '0.4s',
      'animation-delay': '0.9s',
      'transition-timing-function': 'ease-in',
      'animation-fill-mode': 'both',
      'animation-name': 'fadeInLeft'
    }
  },
  marginLeftNeg5: {
    marginLeft: -5
  }
}



// WEBPACK FOOTER //
// ./src/components/Styles/HeroSection.Style.js